import {
  faRightFromBracket,
  faUserXmark,
} from '@fortawesome/pro-light-svg-icons';
import {
  UserMenu,
  UserMenuCompanyCard,
  UserMenuCompanySwitcher,
  UserMenuItem,
  UserMenuLink,
  UserMenuSection,
  UserMenuSeparator,
  UserMenuUserCard,
} from '@/components/shared/UserMenu';
import { useUserMenuIdentity } from '@/hooks/useUserMenuIdentity';
import { useManagementUserMenu } from './hooks/useManagementUserMenu';

/**
 * The user menu in the management area: who you are and the two ways out.
 *
 * The company card stays — an operator does still want to see which account
 * they are signed in under — but without the "View profile" link, which goes to
 * a customer-facing company page.
 */
export function ManagementUserMenu() {
  const identity = useUserMenuIdentity();
  const menu = useManagementUserMenu();

  return (
    <UserMenu trigger={identity.trigger}>
      {identity.hasCompany && (
        <>
          <UserMenuCompanyCard company={identity.company}>
            {menu.companyId && (
              <UserMenuLink
                label={menu.getTranslation('viewProfile')}
                onClick={() => menu.onViewCompanyProfile(menu.companyId!)}
              />
            )}
          </UserMenuCompanyCard>
          <UserMenuSeparator />
        </>
      )}

      {menu.hasCompanies && (
        <>
          <UserMenuCompanySwitcher
            companies={menu.companies}
            search={menu.search}
            onSearchChange={menu.setSearch}
            onSelect={menu.handleSwitchCompany}
          />
          <UserMenuSeparator />
        </>
      )}

      <UserMenuUserCard user={identity.person} email={identity.email} />
      <UserMenuSeparator />

      {menu.isImpersonating && (
        <>
          <UserMenuSection>
            <UserMenuItem
              icon={faUserXmark}
              label={menu.getTranslation('endImpersonation')}
              onClick={menu.onEndImpersonation}
            />
          </UserMenuSection>
          <UserMenuSeparator />
        </>
      )}

      <UserMenuSection>
        <UserMenuItem
          icon={faRightFromBracket}
          label={menu.getTranslation('logOut')}
          onClick={menu.onLogout}
          destructive
        />
      </UserMenuSection>
    </UserMenu>
  );
}
